<template>
  <div class="discovery-form">
    <form-v1 v-if="schemaVersion === 1" :form="form" :font="font" :in-frame="false" :complete="isComplete" ref="form" @complete="saveForm($event)"></form-v1>
    <form-v2 v-if="schemaVersion === 2" :form="form" :font="font" :in-frame="false" :complete="isComplete" ref="form" @complete="saveForm($event)"></form-v2>
		<div v-if="schemaVersion === 0 && !notFound" class="discovery-form__loading">
			<v-progress-circular indeterminate color="primary" :size="36" :width="3" />
		</div>
  </div>
</template>

<script>
	import qs from 'qs';
	import HttpClient from '../../services/HttpClient';
	import WebFontLoader from 'webfontloader';
	import { formBrandFontFamilies } from '@moxie/branding';
	import { resolveDocumentBranding } from '@/utils/portalBranding';
	import CustomFontService from '@/modules/utils/CustomFontService';
  import FormV1 from '@/modules/forms/v1/FormV1';
  import FormV2 from '@/modules/forms/v2/FormV2';

	export default {
		name: 'DiscoveryForm',

    props: ['requestToken'],

		components: { FormV1, FormV2 },

		data() {
			return {
				httpClient: null,
				form: null,
        schemaVersion: 0,
				result: null,
				token: null,
				isComplete: false,
				notFound: false,
				isSending: false,
				font: null,
				customFonts: []
			};
		},

		mounted() {
			if (!this.requestToken) this.$vuetify.theme.dark = false;

      if(!this.requestToken){
        let queryString = qs.parse(self.location.search.slice(1));
        this.token = queryString.token;
      }else{
        this.token = this.requestToken;
      }

      let request = JSON.parse(atob(this.token.split('.')[0]));
      this.podUrl = request.podUrl;
      this.httpClient = new HttpClient(this.podUrl, false);

      this.httpClient
				.get('/api/docs/discovery', {
					params: {
						token: this.token,
					},
				})
				.then((res) => {
					this.form = res.data;
          this.schemaVersion = this.form.schemaVersion;
					this.activateDocumentBranding();
					this.loadFonts();
				})
				.catch((err) => {
					this.notFound = true;
					console.log(err.response.data);
				});
		},

		beforeDestroy() {
			if (!this.requestToken) {
				this.$store.commit('setDocumentBranding', null);
				this.$store.state.eventBus.$emit('document-branding-changed', this.$store.state.darkMode);
			}
		},

		methods: {
			loadFonts: function() {
				const branding = resolveDocumentBranding(this.form.branding, this.$vuetify.theme.dark ? 'dark' : 'light');
				const families = branding ? formBrandFontFamilies(branding) : [this.form.font];
				new CustomFontService(this.podUrl).getCustomFonts(this.form.accountId)
					.then((res) => {
						this.customFonts = Array.isArray(res.data) ? res.data : [];
						return true;
					})
					.catch(() => {
						const sameAccount = this.$store.state.domain && String(this.$store.state.domain.accountId) === String(this.form.accountId);
						this.customFonts = sameAccount ? this.$store.state.accountFonts || [] : [];
						return sameAccount && this.customFonts.length > 0;
					})
					.then((catalogKnown) => {
						if (catalogKnown) [...new Set(families.filter(Boolean))].forEach(this.loadFont);
						else this.setFont();
					});
			},

			activateDocumentBranding() {
				if (this.requestToken) return;
				this.$store.commit('setDocumentBranding', this.form.branding || false);
				this.$store.state.eventBus.$emit('document-branding-changed', this.$store.state.darkMode);
			},

			loadFont: function(fontName) {
				const custom = this.customFonts.find((font) => font.fontName === fontName);
				if (custom) {
					const font = new FontFace(custom.fontName, `url(${custom.fontUrl})`);
					font.load().then((loaded) => document.fonts.add(loaded)).finally(this.setFont);
					return;
				}
				WebFontLoader.load({
					google: { families: [`${fontName}:100,200,300,400,500,600,700,800,900`] },
					active: this.setFont,
				});
			},

			handleResult(result) {
				this.result = result;
			},

			setFont: function() {
				this.font = this.form.font;
			},

			saveForm(result) {
				this.$store.commit('startLoading', 'Submitting your form…');
        let formResult = result.formResult;
        let files = result.files;

				let response = {
					token: this.token,
					formData: formResult,
				};

				let formData = new FormData();
				formData.append('response', JSON.stringify(response));
				files.forEach((a) => {
					formData.append('files', a);
				});

				this.httpClient
					.post('/api/docs/discovery', formData, {
						headers: {
							'Content-Type': 'multipart/form-data',
						},
					})
					.then(() => {
						this.isComplete = true;

            try {
              localStorage.removeItem(`${this.form.accountId}.${this.form.uniqueTemplateId}`);
            }catch(err){
              console.log(err);
            }
					})
					.catch((err) => {
						this.$store.commit('error', err.response.data.status + ' - ' + err.response.data.message);
						console.log(err.response.data);
					})
					.finally(() => {
						this.$store.commit('stopLoading');
            this.$emit('result',true);
					});
			},
		},
	};
</script>

<style scoped lang="scss">
	.discovery-form {
		width: 100%;
		height: 100%;
		min-height: 100vh;

		&__loading {
			min-height: 100vh;
			display: flex;
			align-items: center;
			justify-content: center;
			background: var(--v-gray_10-base);
		}
	}
</style>
